import Pages from "./Routes/Pages";


function App() {
  return (
    <div>
      <Pages />
    </div>
  );
}

export default App;
